import { LookupTnsInputDTO } from "../model/input/lookupTnsInputDTO";
import { LookupTnsOutputDTO } from "../model/output/lookupTnsOutputDTO";
import { respondTns } from "../reducer/conflictCaseReducers";
import axios, { getAuthToken } from "./axios";
import { AxiosPromise } from "./axiosPromise";
import {
  DOWNLOAD_GCRM_ENDPOINT,
  LOOKUP_TNS_BASE_URL,
  LOOKUP_TNS_ENDPOINT,
} from "./serviceConfiguration";

export function lookupTnsAxios(
  input: LookupTnsInputDTO
): AxiosPromise<LookupTnsOutputDTO> {
  if (
    localStorage.getItem("mock_lookup_tn_results") !== null &&
    localStorage.getItem("mock_lookup_tn_results") === "true"
  ) {
    return mockResults(input);
  }

  return axios.post(
    LOOKUP_TNS_BASE_URL + LOOKUP_TNS_ENDPOINT,
    input,
    getAuthToken()
  );
}

function mockResults(
  input: LookupTnsInputDTO
): AxiosPromise<LookupTnsOutputDTO> {
  return new Promise((resolve) => {
    setTimeout(() => {
      let returned: LookupTnsOutputDTO = { data: [] };

      if (input.service === "CID") {
        returned.data = input.tns.map((input) => {
          return {
            tel: "+" + input.tn,
            hni: "310012",
            dns_response_message: "NOERROR(0)",
            npdi: true,
            response_message: "NOERROR",
            dns_response_code: 0,
            response_code: "0",
            pi: true,
            name: "Verizon Wireless, LLC.",
            cic: "+100313",
            iso2: 'US;"',
            type: "Mobile",
            cr: "100313",
          };
        });
      }

      if (input.service === "NCHECK") {
        returned.data = input.tns.map((input) => {
          return {
            tel: "+" + input.tn,
            response_code: 0,
            dns_response_message: "NOERROR(0)",
            response_message: "NOERROR",
            dns_response_code: 0,
            nnci: "4",
            sip: "+17327700780",
          };
        });
      }

      if (input.service === "NVIEW") {
        returned.data = input.tns.map((input) => {
          return {
            tel: "+" + input.tn,
            response_code: 3,
            dns_response_message: "NXDOMAIN(3)",
            response_message: "NXDOMAIN",
            dns_response_code: 3,
          };
        });
      }

      // returned.data.push({
      //   tel: "+" + "12012002000",
      //   hni: "310012",
      //   dns_response_message: "NOERROR(0)",
      //   npdi: true,
      //   response_message: "NOERROR",
      //   dns_response_code: 0,
      //   response_code: "0",
      //   name: "Verizon Wireless, LLC.",
      //   type: "Mobile",
      //   cr: "100313",
      // });

      resolve({
        data: returned,
        status: 200,
        statusText: "OK",
        headers: {},
        //@ts-ignore
        config: {},
      });
    }, 2500);
  });
}

export function downloadLatestGcmr() {
  return axios.get(LOOKUP_TNS_BASE_URL + DOWNLOAD_GCRM_ENDPOINT, {
    responseType: "blob",
    ...getAuthToken(),
  });
}
